// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"549a7841","455":"fe2f6534","977":"16731ffa"}[chunkId] + ".chunk.js";
};